import { render } from "./CardNoticias.vue?vue&type=template&id=58bee518"
import script from "./CardNoticias.vue?vue&type=script&lang=js"
export * from "./CardNoticias.vue?vue&type=script&lang=js"

import "./CardNoticias.vue?vue&type=style&index=0&id=58bee518&lang=css"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__